<template>
  <div>
  <div class="d-flex">
    <UserImgProfile :data="review.reviewer" :allData="review.reviewer" />

    <div class="flex-grow-1 pdl-16 mgb-4">
      <div class="d-flex">
        <i v-for="i in 5" :key="i" :class="i <= review.score ? 't-color-starmark' : 't-color-textfieldGuidLine'" class="material-icons t-headline8">star</i>
        <div class="t-body1 t-color-headlineBlack font-m mgl-8">{{ Math.floor(review.score) }}</div>
      </div>
      <div class="d-flex align-items-center mgt-4">
        <div class="t-body3 t-color-bodyGrayA font-r micro-user-info position-relative" :class="{'t-color-bodyGrayB': review.isBlocked}">{{ review.reviewer ? $t('3437', {first: review.reviewer.name.first, last: review.reviewer.name.last}) : '' }}</div>
        <div class="rightDivider min-h-12"></div>
        <div class="t-body3 t-color-bodyGrayA font-r  micro-user-info position-relative" :class="{'t-color-bodyGrayB': review.isBlocked}">{{ $moment(review.created).format('YYYY.MM.DD') }}</div>
      </div>
      <div :class="{ 'review-content-box': !isSeeMore }" class="t-body2 t-color-headlineBlack font-r t-line-h-24 mgt-8">
        <div :ref="`content-${index}`" :class="[{ 'ellipsis-line-3': !isSeeMore }, {'t-color-bodyGrayB': review.isBlocked}]" class="mgr--24 t-justify t-body1">
          {{ review && review.isBlocked ? $t("3814") : review && review.content ? review.content : "" }}
        </div>
      </div>
      <div v-show="hasButton">
        <div v-if="isSeeMore" class="t-body2 t-color-signBlue font-r t-line-h-24 mgt-8 cursor-pointer" @click="seeLessContent">{{ $t('30218') }}</div>
        <div v-else class="t-body2 t-color-signBlue font-r t-line-h-24 mgt-8 cursor-pointer" @click="seeMoreContent">{{ $t('30211') }}</div>
      </div>
      <div class="mgt-6 pdt-13 pdb-13">
        <button class="mdc-button mdc-button--icon-leading t-color-iconInactive mgl--12 mgt--12" @click="patchLikeReply(review)" v-if="!review.isBlocked">
          <span class="mdc-button__ripple"></span>
          <i :class="review.liked ? 't-color-red' : 't-color-iconInactive'" aria-hidden="true" class="material-icons mdc-button__icon">{{ review.liked ? 'favorite' : 'favorite_border' }}</i>

          <span class="mdc-button__label t-body3 font-r">{{ review.likesCount }}</span>
        </button>
      </div>
    </div>
    <div class="position-relative more-btn-parent-div mdc-menu-anchor menu-container h-24 d-flex align-items-center">
      <button class="mdc-icon-button material-icons js--dropdown-toggle mgr--8" @click.prevent="handleModal()" @keypress.prevent="handleModal()">
        <div class="mdc-icon-button__ripple"></div>
        <i class="material-icons t-color-bodyGrayA dropdownIcon">more_horiz</i>
      </button>
      <UserDetailActionModal
        v-if="isOpenModal"
        :type="'REVIEW'"
        :data="review"
        :selectedChild="makeSelectedChild()"
        @report="goToReport(review)"
        @block="handleBlock"
        @edit="goToEdit(review.id)"
        @delete="goToDelete(review.id)"
        :className="'action-modal'"
      />
    </div>
  </div>
  <div class="divider"></div>
  <div v-if="isOpenModal" @click="closeModal" @keypress="closeModal" class="modal-background" />
  </div>
</template>

<script>
import Section from "@/components/microDegree/view/Section.vue";
import microDegreeApi from "@/api/microDegreeApi";
import snackMessage from "@/plugins/snackMessage";
import localStorageUtil from "@/utils/localStorageUtil";
import UserDetailActionModal from "@/components/common/modal/UserDetailActionModal.vue";
import { userMixin } from "@/mixins/user"

export default {
  name: "ReviewItem",

  mixins: [ userMixin ],

  components: { 
    Section, 
    UserDetailActionModal, 
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
  },

  props: {
    index: {
      type: Number,
      required: true
    },
    review: {
      type: Object,
      required: true
    },
    reviewSet: {
      type: Object,
      required: true
    },
    isMember: {
      type: String,
      required: true
    },
    likeToggle: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      isSeeMore: false,
      hasButton: true,
      fixedHeight: 72,
      bgColorOfName: localStorageUtil.getBgColor(),
      isOpenModal: false,
      selectedId: null,
    }
  },

  computed: {
    reviewListCount() {
      return !this.reviewSet.average ? '0.0' : this.reviewSet.average.toFixed(1)
    },
  },

  mounted() {
    this.isContentLong();
  },

  methods: {
    patchLikeReply(review) {
      this.$emit('likeReply', review)
    },

    isContentLong() {
      this.$nextTick(() => {
        const containers = this.$refs['content-' + this.index];
        if (containers && containers.scrollHeight < this.fixedHeight) {
          this.hasButton = false;
        }
      })
    },

    seeMoreContent() {
      this.isSeeMore = true;
    },

    seeLessContent() {
      this.isSeeMore = false;
      const containers = this.$refs[`content-${this.index}`];
      if (containers) {
        containers.classList.remove('ellipsis-line-3');
      }
    },

    toggleAddedMenu(evt) {
      let field = evt.target.closest(".more-btn-parent-div").querySelector(".more_box");
      field.classList.add('z-200');

      const toggleBackground = document.querySelector('.toggle-menu-scrim-rate');
      let openedMenubar = document.querySelector(".mdc-menu-surface--open");

      if (openedMenubar) {
        openedMenubar.classList.remove("mdc-menu-surface--open");
      }

      field.classList.toggle("mdc-menu-surface--open");
      field.classList.toggle('mdc-menu-surface--is-open-below');

      toggleBackground.classList.remove('d-none');
    },

    getReviewOwner(id) {
      return id === this.isMember;
    },

    // modal handle function
    handleModal(id) {
      this.isOpenModal = !this.isOpenModal;
      this.selectedId = id;
    },

    // modal close function
    closeModal() {
      this.isOpenModal = false;
      this.selectedId = null;
    },

     // 유저 차단
     async handleBlock(item, isBlocked) {
      try {
        await this.blockUser(item, isBlocked, "REVIEW");
      } catch (error) {
        console.log("BOARD BLOCK ERROR : ", error);
      } finally {
        this.closeModal();
        window.location.reload();
      }
    },

    goToEdit(id) {
      this.$router.push({
        name: "MicroDegreeReviewEdit",
        params: {degreeId: this.$route.params.degreeId, id: id},
        query: {learnId: this.$route.params.learnId}
      })
    },

    goToReport(data) {
      this.closeModal();
      if (!data.hasReported) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "REVIEW_MICRO" },
          params: { data, degreeId: this.$route.params.degreeId }
        })
      } else {
        this.closeModal();
        snackMessage(this.$t("3808"));
      }
    },

    goToDelete(id) {
      let params = {
        degreeId: this.$route.params.degreeId,
        reviewId: id
      };
      microDegreeApi.learnDeleteReview(params).then((response) => {
        this.$router.push('/micro-course/' + params.degreeId);
        this.$emit('reviewKeyUpdate')
      })
      this.$emit('menuActivate');
    },

    makeSelectedChild() {
      return {
        modify: true,
        remove: true,
      };
    },
  }
}
</script>

<style scoped>
.mdc-menu-anchor.mdc-menu-surface--open {
  min-width: 112px;
  right: 0 !important;
}

.review-content-box {
  box-sizing: border-box !important;
  /* height: 72px !important; */
  margin: 0;
}

.ellipsis-line-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.micro-dgree-review-list>div:first-child>div .divider {
    display: none !important;
}

.action-modal {
  opacity: 1;
  min-width: 160px !important;
  top: 0;
  right: 0;
  margin-right: 10px;
  margin-top: 30px;
}

.modal-background{
  background: rgba(0, 0, 0, 0.001);
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  margin-top: 120%;
}
</style>
